import React from 'react';
import { Route, Routes, Outlet } from 'react-router';
import LoginPage from './pages/LoginPage/Login.jsx';
import Analysis from './pages/Analysis/Analysis.jsx';
import FilesPage from './pages/FilesPage/FilesPage.jsx';
import { UserProvider } from './context/UserContext.jsx';
import { NotificationProvider } from './context/NotificationContext.jsx';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute.jsx';

const App = () => {
  return (
    <NotificationProvider>
      <UserProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="analysis"
            element={
              <ProtectedRoute>
                <Analysis />
              </ProtectedRoute>
            }
          />
          <Route
            path="analysis/:file_id"
            element={
              <ProtectedRoute>
                <Analysis />
              </ProtectedRoute>
            }
          />
          <Route
            path="files"
            element={
              <ProtectedRoute>
                <FilesPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </UserProvider>
    </NotificationProvider>
  );
};

export default App;
